import React, { memo } from 'react';
import { Typography } from 'antd';
import NodeLabel from './NodeLabel';
import { useNodeTitle } from './useNodeTitle';

const GroupNode = ({ id, data, selected }) => {
    const onTitleChange = useNodeTitle(id, data, 'label');
    return (
        <div style={{
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(22, 27, 34, 0.4)', // Dark semi-transparent
            border: `2px dashed ${selected ? '#1890ff' : '#30363d'}`,
            borderRadius: 32,
            padding: 40, // Increased padding
            position: 'relative',
            transition: 'all 0.2s',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
        }}>
            <NodeLabel
                title={data.label || 'Group'}
                iconType="group"
                color="transparent" // Allow label to handle color, or transparent if label has its own style
                style={{ top: -28, left: 16 }} // Position adjustment
                onTitleChange={onTitleChange}
            />
        </div>
    );
};

export default memo(GroupNode);
